import { render, staticRenderFns } from "./mytpp-training-test.vue?vue&type=template&id=662d56ce&scoped=true"
import script from "./mytpp-training-test.vue?vue&type=script&lang=js"
export * from "./mytpp-training-test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d56ce",
  null
  
)

export default component.exports